export default  {
  bindings: {
    order: '=',
    formTab: '=',
    orderStatuses: '<',
    paymentStatuses: '<'
  },
  controller: 'orderFormController',
  template: require('../views/order.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/components/order.form.component.js